module.exports = __webpack_public_path__ + "static/Hirafi-poster-5b8f70a2eb7c7d10b9c4a7dd7194048f.jpg";